import { render, staticRenderFns } from "./ZapTable.vue?vue&type=template&id=6ff8ef8e&scoped=true&"
import script from "./ZapTable.vue?vue&type=script&lang=js&"
export * from "./ZapTable.vue?vue&type=script&lang=js&"
import style0 from "./ZapTable.vue?vue&type=style&index=0&id=6ff8ef8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff8ef8e",
  null
  
)

export default component.exports